import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

interface TopicSelectProps {
  topics: { id: string; name: string }[];
  value?: string;
  onChange?: (value: string) => void;
}

export const TopicSelect = ({ topics, value, onChange }: TopicSelectProps) => {
  return (
    <Select value={value} onValueChange={onChange}>
      <SelectTrigger className="w-[200px]">
        <SelectValue placeholder="Topic" />
      </SelectTrigger>
      <SelectContent className="bg-background border z-50">
        {topics.filter(t => t.id && t.id.trim() !== '').map((t) => (
          <SelectItem key={t.id} value={t.id}>{t.name}</SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};
